import { isNil } from '#packages/data-collection/libs/lodash';
import { useCallback, useState } from 'react';

export type MenuState = 'open' | 'closed';

export const useMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = useCallback((el: HTMLElement) => {
    setAnchorEl(el);
  }, []);
  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const state: MenuState = isNil(anchorEl) ? 'closed' : 'open';

  return {
    open,
    close,

    isOpen: state === 'open',
    isClosed: state === 'closed',

    state,
    anchorEl,
  };
};
